module.exports = __webpack_public_path__ + "img/HQ-G45-V2-ALL.322de5f0.png";